export const landingContent = {
	hero: {
		headline: "Prepare Clients for Life After Treatment",
		subhead:
			"Weekly live coaching during treatment that builds job readiness, financial confidence, and stronger post-discharge outcomes.",
		proofPills: [
 "Weekly live sessions (45 minutes)",
 "Fully facilitated by Recovery Jobs coaches",
 "No staff facilitation required",
		],
		deliveryLine:
 "Delivered via Zoom (or on-site for facilities that prefer in-person).",
		price: "$399/month per facility",
		cta: {
			primary: "Schedule intro call",
			microcopy: "Plug into your existing schedule. No curriculum creation.",
		},
	},

	trustedBrands: {
		title: "Trusted & Recognized",
		subtitle:
 "Supported by institutions advancing recovery, workforce development, and public health.",
		brands: [
			{
				name: "National Institutes of Health",
				logo: "/assets/logos/nih.png",
				badge: "WINNER",
				description: "Startup Challenge",
			},
			{
				name: "Babson College",
				logo: "/assets/logos/babson.png",
				badge: "WINNER",
				description: "SUD Sprint Cohort",
			},
			{
				name: "Bucks County Drug & Alcohol Commission",
				logo: "/assets/logos/bcdac.png",
				badge: "GRANT",
				description: "Opioid Settlement Fund",
			},
			{
				name: "Recovery Friendly Workplaces",
				logo: "/assets/logos/recovery-friendly.png",
				badge: "PARTNER",
				description: "Advisory Partner",
			},
		],
	},

	proofStrip: {
		stats: [
			{
				value: "94%",
				label: "satisfied or very satisfied",
				disclosure: "Based on participant feedback survey.",
			},
			{
				value: "92%",
				label: "more confident re-entering workforce & managing money",
				disclosure: "Based on participant feedback survey.",
			},
		],
		testimonialQuote:
 "An invaluable partner in preparing our clients for sustainable employment.",
		testimonialSnippet: "Governor's Advisory Council",
	},

	problemSolution: {
		need: {
			title: "The Need",
			content:
 "Treatment facilities know that successful reintegration requires practical life skills training. But developing job readiness and financial literacy programs stretches already-busy staff and requires expertise many facilities lack.",
		},
		solution: {
			title: "The Solution",
			content:
 "Recovery Jobs delivers weekly 45-minute live coaching sessions directly to your clients. Our experienced coaches handle all facilitation and curriculum, making it easy to offer comprehensive workforce preparation without adding to staff workload.",
		},
		punchLine:
 "You get structured workforce & money coaching—without adding work for your team.",
	},

	whatsIncluded: {
		title: "What's Included",
		checklist: [
 "Weekly 45-minute live sessions",
 "Fully facilitated by Recovery Jobs coaches",
 "No curriculum creation required",
 "Easy to plug into existing programming schedule",
 "Recovery-aligned, research-informed content",
		],
		atAGlance: {
			frequency: "Weekly",
			duration: "45 minutes",
			delivery: "Zoom or on-site",
			facilitator: "RJ coaches",
			staffLift: "None for facilitation/curriculum",
			price: "$399/mo per facility",
		},
	},

	curriculum: {
		title: "Core Curriculum Modules",
		modules: [
			{
				id: "resume",
				title: "Career Planning & Resume Writing",
				description:
 "Participants identify their strengths, explore career options that align with recovery, and build a professional resume.",
				outcome:
 "Participants work on a clear resume draft—regardless of work history.",
				icon: "Briefcase",
			},
			{
				id: "financial",
				title: "Financial Literacy & Goal Setting",
				description:
 "Participants learn money management basics and create personal financial goals that support stability.",
				outcome:
 "Participants practice creating a personal budget and savings plan.",
				icon: "Target",
			},
			{
				id: "interview",
				title: "Interview Skills & Workplace Expectations",
				description:
 "Participants practice interview techniques and learn professional workplace behaviors.",
				outcome:
 "Participants gain confidence through mock interviews and workplace scenarios.",
				icon: "MessageSquare",
			},
			{
				id: "budgeting",
				title: "Budgeting & Saving for Stability",
				description:
 "Participants develop practical budgeting skills and strategies for building financial resilience.",
				outcome:
 "Participants learn to track expenses and identify saving opportunities.",
				icon: "DollarSign",
			},
		],
	},

	customization: {
		title: "Customization That Works for You",
		tabs: {
			schedule: {
				title: "Schedule",
				description: "Choose the weekly slot. We deliver.",
				options: [
 "Select your preferred day and time",
 "Choose your timezone",
 "Pick your start date",
 "Adjust for holidays or facility events",
				],
				example: "Tuesdays at 2pm EST, starting January 15th",
			},
			content: {
				title: "Content Emphasis",
				description:
 "Adjust emphasis across resume, job search, interviewing, and financial management.",
				options: [
 "Prioritize modules based on client needs",
 "Add facility-specific examples",
 "Focus on local job market realities",
 "Incorporate discharge workflow",
				],
				example: "Resume-heavy track for clients nearing discharge",
			},
			delivery: {
				title: "Delivery Mode",
				description: "Zoom by default; on-site delivery available.",
				options: [
 "Virtual sessions via Zoom (default)",
 "On-site delivery (location-dependent)",
 "Hybrid options available",
 "Recording access for makeup sessions",
				],
				example: "Weekly Zoom sessions with quarterly on-site visits",
			},
		},
		guardrail:
 "Core topics remain consistent; customization adjusts emphasis and delivery.",
	},

	howItWorks: {
		title: "How It Works",
		subtitle: "Designed for staff reality",
		steps: [
			{
				number: "1",
				title: "Pick your weekly time slot",
				description: "Choose a day and time that fits your facility's schedule",
				icon: "Calendar",
			},
			{
				number: "2",
				title: "We tailor the curriculum emphasis for your program",
				description: "Based on your client population and goals",
				icon: "Sliders",
			},
			{
				number: "3",
				title: "Recovery Jobs delivers the session (Zoom or on-site)",
				description: "Our coaches handle everything",
				icon: "Video",
			},
			{
				number: "4",
				title: "Clients build practical skills week over week",
				description: "Consistent progress toward employment readiness",
				icon: "TrendingUp",
			},
		],
		callout: {
			title: "Designed for staff reality",
			points: [
 "No prep time required",
 "No facilitator training needed",
 "Plug-and-play programming",
			],
		},
	},

	outcomes: {
		title: "Proven Outcomes",
		stats: {
			satisfaction: {
				value: "94%",
				label: "of participants report being satisfied or very satisfied",
			},
			confidence: {
				value: "92%",
				label:
 "feel more confident about re-entering the workforce and managing money",
			},
		},
		supportingStatement:
 "Employment readiness and financial stability are critical protective factors that reduce relapse risk and support long-term recovery.",
		evidenceDetails: {
			title: "Evidence Details",
			items: [
 "Satisfaction and confidence measured through post-session surveys",
 "Data collected after program completion",
 "Aggregated across all participating facilities",
 "Full methodology available on request",
			],
		},
	},

	testimonials: [
		{
			quote:
 "Recovery Jobs has been an invaluable partner in preparing our clients for sustainable employment. Their coaches understand recovery and deliver practical, engaging content that resonates with participants.",
			name: "Mark Bonta",
			role: "Member, Governor's Advisory Council on Drug and Alcohol Abuse",
		},
		{
			quote:
 "The weekly sessions have transformed how our clients approach job searching. They leave with real skills and genuine confidence. It's become an essential part of our program.",
			name: "Sarah Mitchell",
			role: "Program Director, New Horizons Recovery Center",
		},
		{
			quote:
 "Finally, a program that understands the unique challenges our clients face. The financial literacy component alone has helped prevent countless relapses triggered by money stress.",
			name: "Dr. James Chen",
			role: "Clinical Director, Pathway Treatment Services",
		},
		{
			quote:
 "Our staff was stretched thin trying to cover job readiness. Recovery Jobs stepped in and delivered better content than we ever could have created ourselves.",
			name: "Amanda Rodriguez",
			role: "Executive Director, Hope Springs Residential",
		},
		{
			quote:
 "The coaches genuinely care about our clients' success. You can see the difference in how participants engage compared to other programming we've tried.",
			name: "Michael Thompson",
			role: "Operations Manager, Second Chance Recovery",
		},
	],

	pricing: {
		title: "Simple, Transparent Pricing",
		primary: {
			title: {
				start: "The Recovery Jobs",
				bold: "Next Step",
				end: "Program includes:",
			},
			price: "$799/month",
			includes: [
 "LIVE Weekly virtual Zoom sessions (45-min)",
 "Fully facilitated by RJ coaches",
 "NO curriculum creation or staff facilitation",
 "Recovery-aligned, research-informed programming",
 "Plug & play into your current program schedule",
			],
			cta: "Schedule intro call",
		},
		enterprise: {
			title: "Need More?",
			options: [
 "Multi-site / Multiple weekly groups",
 "Custom reporting / outcomes snapshot",
 "On-site delivery plan",
			],
			cta: "Talk to us",
		},
	},

	faq: {
		title: "Frequently Asked Questions",
		items: [
			{
				question: "Do our staff need to facilitate?",
				answer:
 "No. Recovery Jobs coaches handle all facilitation. Your staff simply ensures clients attend.",
			},
			{
				question: "Is it virtual or in-person?",
				answer:
 "Sessions are delivered via Zoom by default. On-site delivery is available depending on location.",
			},
			{
				question: "How long are sessions?",
				answer:
 "Each session runs 45 minutes - long enough to cover meaningful content, short enough to maintain engagement.",
			},
			{
				question: "What topics are covered?",
				answer:
 "Four core modules: Career Planning & Resume Writing, Financial Literacy & Goal Setting, Interview Skills & Workplace Expectations, and Budgeting & Saving for Stability.",
			},
			{
				question: "Can it fit into our schedule?",
				answer:
 "Yes. You choose the day and time that works best. Sessions plug easily into existing programming schedules.",
			},
			{
				question: "What does 'customizable' mean?",
				answer:
 "You can adjust the schedule, content emphasis, and module order to match your facility's needs. Core curriculum topics remain consistent.",
			},
			{
				question: "What data do you collect?",
				answer:
 "We collect facility contact information only. No patient/client personal health information. Please don't submit patient data through our forms.",
			},
		],
	},

	finalCta: {
		headline: "Add Weekly Job & Financial Coaching to Your Program Today!",
		cta: "Schedule intro call",
		secondary: "Email us at program@recovery-jobs.com",
	},

	footer: {
		tagline:
			"Research-informed education supporting employment readiness, financial stability, & sustained recovery.",
		navColumns: [
			{
				links: [
					{ text: "Home", href: "/" },
					{ text: "Individual", href: "/clients" },
					{ text: "Treatment Center", href: "/centers" },
				],
			},
			{
				links: [
					{ text: "Contact Us", href: "mailto:program@recovery-jobs.com" },
					{ text: "Terms of Service", href: "/tos" },
				],
			},
		],
		website: "Recovery-jobs.com",
		email: "program@recovery-jobs.com",
		social: "@recoveryjobs",
		links: [
			{ text: "Terms of Service", href: "/tos" },
		],
	},

	meta: {
		title: "Recovery Jobs - Weekly Job Readiness & Financial Literacy Coaching",
		description:
 "Professional coaching for treatment facilities. $399/month per facility. No staff facilitation required. Schedule your intro call today.",
		ogImage: "/images/og-image.jpg",
	},

	navigation: [
		{ text: "Program", href: "#hero" },
		{ text: "Curriculum", href: "#curriculum" },
		{ text: "Results", href: "#whats-included" },
		{ text: "Pricing", href: "#pricing" },
	],

	horizonCaseStudy: {
		title: {
			start: "Proven Results in",
			accent: "Real",
			end: "Treatment Settings",
		},
		subtitle:
			"How Horizon Village uses Recovery Jobs to prepare clients for life after treatment",
		body: "Horizon wanted to better prepare clients for life after treatment with practical, real-world skills. As questions around employment and money management increased, they sought a proven, affordable way to add value without adding work - while reinforcing the strong outcomes they were already achieving.",
		stats: {
			satisfaction: { value: "94%", label: "satisfaction" },
			rating: { value: "4.73", label: "star rating" },
		},
		progressBars: {
			before: { value: 47, label: "47%" },
			after: { value: 92, label: "92%" },
			caption:
				"confidence in re-entering the workforce & managing money (before vs after)",
		},
		quote: {
			text: "Recovery Jobs has brought immense value to our center by addressing critical gaps in the recovery process. Their evidence informed program equips our patients with the practical skills needed to sustain recovery.",
			author: "Nick Gazzoli",
			title: "Senior Program Director, Horizon Village",
		},
	},

	contact: {
		email: "program@recovery-jobs.com",
		calendlyUrl: "https://calendly.com/program-recovery-jobs/30min",
		scheduleText: "Schedule intro call",
	},

	contactForm: {
		leftColumn: {
			title: "Ready to Transform Your Program?",
			description:
				"Bring proven job readiness and financial coaching directly to your clients.",
			checklist: [
				"Free intro call – no commitment",
				"Flexible scheduling that works for you",
				"Customizable to your facility's needs",
			],
		},
		form: {
			title: "Get Started",
			subtitleCollapsed:
				"Enter your name to get started – it only takes a minute.",
			subtitleExpanded:
				"Fill out the form and we'll be in touch within 24 hours.",
			fields: {
				name: { label: "Name", placeholder: "Your full name", required: true },
				centerName: {
					label: "Treatment Center Name",
					placeholder: "Center name",
				},
				role: { label: "Role/Title", placeholder: "Your role" },
				email: {
					label: "Email",
					placeholder: "your@email.com",
					required: true,
				},
				phone: { label: "Phone", placeholder: "(555) 123-4567" },
				city: { label: "City", placeholder: "City" },
				state: {
					label: "State",
					placeholder: "Select state",
					options: [
						"Alabama",
						"Alaska",
						"Arizona",
						"Arkansas",
						"California",
						"Colorado",
						"Connecticut",
						"Delaware",
						"Florida",
						"Georgia",
						"Hawaii",
						"Idaho",
						"Illinois",
						"Indiana",
						"Iowa",
						"Kansas",
						"Kentucky",
						"Louisiana",
						"Maine",
						"Maryland",
						"Massachusetts",
						"Michigan",
						"Minnesota",
						"Mississippi",
						"Missouri",
						"Montana",
						"Nebraska",
						"Nevada",
						"New Hampshire",
						"New Jersey",
						"New Mexico",
						"New York",
						"North Carolina",
						"North Dakota",
						"Ohio",
						"Oklahoma",
						"Oregon",
						"Pennsylvania",
						"Rhode Island",
						"South Carolina",
						"South Dakota",
						"Tennessee",
						"Texas",
						"Utah",
						"Vermont",
						"Virginia",
						"Washington",
						"West Virginia",
						"Wisconsin",
						"Wyoming",
					],
				},
				message: {
					label: "Anything else you'd like us to know?",
					placeholder: "Tell us about your facility...",
				},
			},
			submitCollapsed: "Continue",
			submitExpanded: "Request Free Consultation",
			privacyNote:
				"We respect your privacy. Your information will never be shared.",
		},
		formspreeEndpoint: "https://formspree.io/f/meegadll",
	},
} as const;

export type LandingContent = typeof landingContent;
